// Mystery Box — exclude-clubs picker.
// Port z sites/release/assets/partials.js linie 1243-1321 (bindExcludeClubs)
// + integracja z hidden input do form submit + size picker.

function initExcludeClubs(root) {
  root.querySelectorAll('[data-exclude-clubs]').forEach(host => {
    if (host.dataset.kbExcludeBound === '1') return;
    host.dataset.kbExcludeBound = '1';

    const trigger = host.querySelector('[data-exclude-trigger]');
    const panel = host.querySelector('[data-exclude-panel]');
    const label = host.querySelector('[data-exclude-label]');
    const search = host.querySelector('[data-exclude-search]');
    const checks = host.querySelectorAll('[data-exclude-check]');
    const clearBtn = host.querySelector('[data-exclude-clear]');
    const doneBtn = host.querySelector('[data-exclude-done]');
    const chips = host.querySelector('[data-exclude-chips]');
    const hiddenInput = host.querySelector('[data-exclude-input]');
    const max = parseInt(host.getAttribute('data-max') || '2', 10);
    if (!trigger || !panel || !label) return;

    const placeholder = label.textContent;

    let hint = panel.querySelector('[data-exclude-hint]');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'exclude-hint';
      hint.setAttribute('data-exclude-hint', '');
      hint.textContent = `Wybierz maksymalnie ${max} ${max === 1 ? 'klub' : 'kluby'}`;
      const actions = panel.querySelector('.exclude-actions');
      if (actions) panel.insertBefore(hint, actions);
      else panel.appendChild(hint);
    }

    function selected() {
      return Array.from(checks).filter(c => c.checked);
    }

    function renderLabel() {
      const sel = selected();
      if (!sel.length) {
        label.textContent = placeholder;
        label.classList.remove('has-selection');
      } else if (sel.length === 1) {
        label.textContent = sel[0].dataset.name;
        label.classList.add('has-selection');
      } else {
        label.textContent = sel.map(c => c.dataset.name).join(' · ');
        label.classList.add('has-selection');
      }
    }

    function renderChips() {
      if (!chips) return;
      chips.innerHTML = '';
      selected().forEach(c => {
        const chip = document.createElement('span');
        chip.className = 'exclude-chip';
        const text = document.createElement('span');
        text.textContent = c.dataset.name || c.value;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'exclude-chip-x';
        btn.setAttribute('aria-label', 'Usuń');
        btn.textContent = '×';
        btn.addEventListener('click', () => {
          c.checked = false;
          updateState();
        });
        chip.appendChild(text);
        chip.appendChild(btn);
        chips.appendChild(chip);
      });
    }

    function updateHiddenInput() {
      if (!hiddenInput) return;
      hiddenInput.value = selected().map(c => c.value).join(',');
    }

    function updateState() {
      const sel = selected();
      checks.forEach(c => {
        if (c.checked) return;
        c.disabled = sel.length >= max;
        const item = c.closest('.exclude-item');
        if (item) item.classList.toggle('is-disabled', sel.length >= max);
      });
      hint.classList.toggle('is-reached', sel.length >= max);
      renderLabel();
      renderChips();
      updateHiddenInput();
    }

    function open() {
      panel.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
      if (search) setTimeout(() => search.focus(), 50);
    }

    function close() {
      panel.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', () => {
      if (panel.classList.contains('open')) close();
      else open();
    });

    document.addEventListener('click', e => {
      if (!host.contains(e.target) && panel.classList.contains('open')) close();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && panel.classList.contains('open')) close();
    });

    checks.forEach(c => c.addEventListener('change', () => {
      if (c.checked && selected().length > max) {
        c.checked = false;
      }
      updateState();
    }));

    if (clearBtn) clearBtn.addEventListener('click', () => {
      checks.forEach(c => { c.checked = false; });
      updateState();
    });

    if (doneBtn) doneBtn.addEventListener('click', close);

    if (search) search.addEventListener('input', () => {
      const q = search.value.trim().toLowerCase();
      host.querySelectorAll('[data-exclude-item]').forEach(item => {
        const name = item.getAttribute('data-club-name')
          || (item.querySelector('span:last-of-type')?.textContent || '').toLowerCase();
        item.style.display = (!q || name.includes(q)) ? '' : 'none';
      });
      host.querySelectorAll('[data-exclude-group]').forEach(grp => {
        const anyVisible = Array.from(grp.querySelectorAll('[data-exclude-item]')).some(i => i.style.display !== 'none');
        grp.style.display = anyVisible ? '' : 'none';
      });
    });

    updateState();
  });

  // Mystery box — rozmiary jako kafle. Przy 1 sztuce klik wybiera rozmiar; przy większej
  // ilości każdy kafel ma −/+, więc 8 boxów może być np. 2×S, 2×M, 2×L, 2×XL.
  // Wynik: ukryte pole = rozmiar ostatniej grupy, `data-msize-groups` = [[rozmiar, ile], …]
  // (czyta to pdp-ajax-atc.js i dodaje każdą grupę jako osobną pozycję koszyka).
  root.querySelectorAll('[data-msize]').forEach(host => {
    if (host.dataset.kbMsizeBound === '1') return;
    host.dataset.kbMsizeBound = '1';

    const input = host.querySelector('[data-msize-input]');
    const status = host.querySelector('[data-msize-status]');
    const tiles = Array.from(host.querySelectorAll('[data-msize-tile]'));
    const form = host.closest('form.cart');
    if (!input || !status || !tiles.length || !form) return;

    const ile = new Map(tiles.map(t => [t.getAttribute('data-msize-tile'), 0]));
    const sztuk = () => Math.max(1, parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1);
    const wybrano = () => Array.from(ile.values()).reduce((a, b) => a + b, 0);
    let ostatni = '';   // rozmiar kliknięty jako ostatni
    let poprzednio = 0; // ilość sztuk przy poprzednim przeliczeniu

    function render(blad) {
      const n = sztuk();
      // Komplet rozmiarów i klient dokłada sztuki: nowe dostają ostatnio kliknięty rozmiar,
      // żeby „8 × L" nie wymagało ośmiu kliknięć. Inny podział robi się potem przez −/+.
      if (ostatni && n > poprzednio && wybrano() === poprzednio) ile.set(ostatni, ile.get(ostatni) + n - poprzednio);
      poprzednio = n;
      // Ilość spadła poniżej wybranych rozmiarów — zdejmujemy nadmiar od końca listy.
      for (const sz of Array.from(ile.keys()).reverse()) {
        while (wybrano() > n && ile.get(sz) > 0) ile.set(sz, ile.get(sz) - 1);
      }
      const suma = wybrano();
      host.classList.toggle('is-multi', n > 1);
      tiles.forEach(t => {
        const c = ile.get(t.getAttribute('data-msize-tile'));
        t.classList.toggle('is-active', c > 0);
        t.querySelector('[data-msize-opt]').setAttribute('aria-pressed', c > 0 ? 'true' : 'false');
        t.querySelector('[data-msize-count]').textContent = String(c);
        t.querySelector('[data-msize-dec]').disabled = c === 0;
        t.querySelector('[data-msize-inc]').disabled = suma >= n;
      });
      const grupy = Array.from(ile.entries()).filter(([, c]) => c > 0);
      const komplet = suma === n;
      input.value = komplet ? grupy[grupy.length - 1][0] : '';
      host.dataset.msizeGroups = komplet ? JSON.stringify(grupy) : '';
      status.classList.toggle('is-error', !!blad && !komplet);
      if (blad && !komplet) {
        status.textContent = n > 1 ? `Wybierz rozmiary dla wszystkich sztuk: masz ${suma} z ${n}.` : 'Wybierz rozmiar.';
      } else {
        status.textContent = n > 1 ? `Wybrane rozmiary: ${suma} z ${n} szt.` : '';
      }
    }

    host.addEventListener('click', (e) => {
      const tile = e.target.closest('[data-msize-tile]');
      const btn = e.target.closest('button');
      if (!tile || !btn) return;
      const sz = tile.getAttribute('data-msize-tile');
      const n = sztuk();
      ostatni = sz;
      if (btn.hasAttribute('data-msize-dec')) {
        ile.set(sz, Math.max(0, ile.get(sz) - 1));
      } else if (n === 1) {
        ile.forEach((_, k) => ile.set(k, k === sz ? 1 : 0));
      } else if (wybrano() < n) {
        ile.set(sz, ile.get(sz) + 1);
      }
      render();
    });

    // Zmiana pakietu albo ilości zmienia liczbę rozmiarów do wybrania.
    form.addEventListener('change', (e) => {
      if (e.target.name === 'quantity' || e.target.name === 'kb_mystery_pack') render();
    });

    // Bez kompletu rozmiarów nie wysyłamy — komunikat pod kaflami, przewinięcie do nich.
    form.addEventListener('submit', (e) => {
      render();
      if (input.value) return;
      e.preventDefault();
      render(true);
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
      host.classList.add('kb-shake');
      setTimeout(() => host.classList.remove('kb-shake'), 500);
    });

    render();
  });

  // Pakiet 1/2/3+ — radio steruje `input[name="quantity"]` w ATC form + active outline.
  root.querySelectorAll('[data-mystery-extras]').forEach(extras => {
    if (extras.dataset.kbPackBound === '1') return;
    extras.dataset.kbPackBound = '1';

    const options = extras.querySelectorAll('.kb-pack-option');
    const radios  = extras.querySelectorAll('[data-mystery-pack]');
    const form    = extras.closest('form.cart') || document.querySelector('form.cart');
    const qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    const qtyBox   = form ? form.querySelector('[data-kb-qty]') : null;

    function packValue() {
      const active = extras.querySelector('[data-mystery-pack]:checked');
      return active ? parseInt(active.value, 10) : 1;
    }

    // Pakiety 1 i 2 same ustawiają ilość (natywny +/- ukryty); „3+" odsłania +/-,
    // żeby dało się zamówić 4, 8 itd. — nie mniej niż 3.
    function sync() {
      const active = extras.querySelector('[data-mystery-pack]:checked');
      const v = packValue();
      options.forEach(o => {
        const isActive = o.contains(active);
        o.classList.toggle('kb-pack-active', isActive);
      });
      if (qtyBox) qtyBox.style.display = v >= 3 ? '' : 'none';
      if (qtyInput) {
        qtyInput.value = v >= 3 ? String(Math.max(3, parseInt(qtyInput.value, 10) || 3)) : String(v);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    radios.forEach(r => r.addEventListener('change', sync));
    if (qtyInput) qtyInput.addEventListener('change', () => {
      if (packValue() >= 3 && (parseInt(qtyInput.value, 10) || 0) < 3) qtyInput.value = '3';
    });
    sync();
  });
}

function boot() {
  initExcludeClubs(document);
}

if (document.readyState !== 'loading') boot();
else document.addEventListener('DOMContentLoaded', boot);
